import { inject, injectable } from "inversify";
import { IAnalyticsService } from "../interfaces/analyticsService";
import { AnalyticsEvent } from "../../models/analytics";
import { ILoggingServiceId, ILoggingService } from "../interfaces/loggingService";
import { AnalyticsEventName } from "../../enums/analyticsEventName";

@injectable()
class AnalyticsService implements IAnalyticsService {

    constructor(
        @inject(Symbol.for("Gtag.Gtag")) private googleGTag: Gtag.Gtag,
        @inject(ILoggingServiceId) private logger: ILoggingService
    ) { }

    public RecordEvent(eventName: AnalyticsEventName, dataValues?: AnalyticsEvent): void {
        try {
            if (this.googleGTag != null) {

                if (dataValues) {
                    // if the event has any property data then convert it into GTM-friendly properties
                    this.googleGTag.call(this, 'event', eventName.toString(), dataValues.convertToGTMEvent(this.logger));
                }
                else {
                    this.googleGTag.call(this, 'event', eventName.toString());
                }
            }
        } catch (e) {
            this.logger.LogError('Unable to record event interaction due to error: ' + e);
        }
    }
};

export { AnalyticsService }